module.exports = __webpack_public_path__ + "static/media/approve-maintenance.04991114.svg";